import { AnalyticsBrowser } from '@segment/analytics-next';

const writeKey: string = import.meta.env.VITE_SEGMENT_API_KEY ?? '';

export const analytics = AnalyticsBrowser.load({ writeKey });
